/* global chmln */

const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Constant values and global singleton services for the learn app Application
 */
app.factory('TrackOrganization', ['Application', 'Authorization', 'Tracks', 'UserTracks', '$q', 'Analyze', 'ErrorReporting', 'Content', function(Application, Authorization, Tracks, UserTracks, $q, Analyze, ErrorReporting, Content) {
  var OrganizedTrack = function (trackId, userId, options, fullCourse) {
    this.fullCourse = fullCourse;
    this.originalTrack = null;
    this.originalUserTrack = null;
    this.trackId = trackId;
    if (this.trackId && this.trackId.indexOf('?')) {
      this.trackId = this.trackId.split('?')[0];
    }
    this.userId = userId;
    this.totalDuration = 0;
    this.totalCourses = 0;
    this.completedCourses = 0;
    this.track = [];
    this.contentDirectory = {};
    this.typesDirectory = {
      'article': 'articles',
      'video': 'videos',
      'file': 'files',
      'quiz': 'quizzes',
      'assessment': 'assessments',
      'articles': 'article',
      'videos': 'video',
      'files': 'file',
      'quizzes': 'quiz',
      'assessments': 'assessment',
      'media': 'media',
      'scorm': 'scorm'
    };

    if (typeof options !== 'object') {
      return;
    }

    for (var key in options) {
      this[key] = options[key];
    }
  };

  OrganizedTrack.prototype.getErrorInfo = function () {
    return {
      user: Authorization.getAuthToken().user._id,
      company: Authorization.getAuthToken().company._id,
      track: this.originalTrack && this.originalTrack._id || this.trackId || null,
      userTrack: this.originalUserTrack && this.originalUserTrack._id || null
    };
  };

  // sorting helper function
  OrganizedTrack.prototype.sortBy = function (items, parameter, order) {
    order = order === undefined ? 1 : order;

    items.sort(function (a, b) {
      if (a[parameter] < b[parameter]) {
        return (-1 * order);
      }
      if (a[parameter] > b[parameter]) {
        return (1 * order);
      }
      return 0;
    });

    return items;
  };

  // helper function to format duration
  OrganizedTrack.prototype.formatDuration = function(time) {
    var mins = ~~(time / 60);
    var secs = time % 60;

    var hrs = ~~(time / 3600);
    var mins = ~~((time % 3600) / 60);
    var secs = time % 60;

    var ret = "";

    if (hrs > 0) {
      ret += "" + hrs + (hrs === 1 ? " hr" : " hrs") + " ";
    }

    ret += "" + mins + (mins === 1 ? " min" : " mins");

    return ret;
  };

  // Get track
  OrganizedTrack.prototype.getTrack = function() {
    var requestBody = {
      subresource: this.trackId, 
      fields: 'name,user,draft,explore_hide,description,category,topic,creator_name,creator_bio,creator_image,creator_link,creator_notes,creator_linkedin,creator_facebook,creator_twitter,creator_slack,creator_github,creator_instagram,creator_youtube,creator_dribbble,learn_items,images,duration,quiz,sequential,tags,sections,linked_category,banner_image,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,resource,certificate,certificate_data,rating_configuration,average_rating,allow_comments,lock_scorm,groups,surveys',
      'sections.courses.article-populate': 'title,duration,type',
      'sections.courses.video-populate': 'title,duration,type',
      'sections.courses.file-populate': 'title,duration,type',
      'sections.courses.quiz-populate': 'title,duration,type',
      'sections.courses.assessment-populate': 'title,duration,type,video_assessment',
      'sections.courses.scorm-populate': 'title,duration,type'
    };

    if (this.fullCourse) {
      requestBody['sections.courses.article-populate'] = 'title,duration,content,summary,author,image,banner_image';
      requestBody['sections.courses.video-populate'] = 'title,duration,author,source,source_id,youtube_id,type,description,completion_percent';
      requestBody['sections.courses.file-populate'] = 'title,duration,author,source,source_id,link,type,description,completion_percent';
      requestBody['sections.courses.quiz-populate'] = 'title,duration,description,questions,questions.answers';
      requestBody['sections.courses.assessment-populate'] = 'company,user,type,questions,title,description,archived,private,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,image,banner_image,cover_justification,featured_justification,explore_hide,tags,published,allow_retake,number_of_retakes,show_user_correct,show_user_correct_after_fail,show_user_grade,video_assessment,file_assessment,creator_name,groups';
      requestBody['sections.courses.scorm-populate'] = 'title,duration,description,author,image,banner_image';
    }
    return Tracks.get(requestBody).$promise;
  };

  // Get user track
  OrganizedTrack.prototype.getUserTrack = function() {
    return UserTracks.find({
      user: this.userId,
      track: this.trackId,
      fields: 'track,user,completed_articles,completed_media,completed_quizzes,completed_assessments,completed_scorm,completed_date,last_viewed,viewed_certificate'
    }).$promise;
  };

  OrganizedTrack.prototype.userCompleted = function(userTrack) {
    var completedItems = {};
    var uTrack = userTrack || this.originalUserTrack;
    function markComplete (items, completed) {
      if (!items || !items.length) {
         return;
      }
      for (var i = 0; i < items.length; i++ ){
        if (!items[i] || typeof items[i] !== 'string') { 
          continue;
        }
        completed[items[i]] = true;
      }
    };

    markComplete(uTrack.completed_quizzes, completedItems);
    markComplete(uTrack.completed_media, completedItems);
    markComplete(uTrack.completed_articles, completedItems);
    markComplete(uTrack.completed_assessments, completedItems);
    markComplete(uTrack.completed_scorm, completedItems);

    return completedItems;
  };

  OrganizedTrack.prototype.orderTrack = function() {
    var self = this;
    this.track = [];
    this.totalCourses = 0;
    this.totalDuration = 0;

    if (!this.originalTrack.sections || !this.originalTrack.sections.length) {
      return;
    }

    this.originalTrack.sections.forEach(function(section) {
      var organizedSection = Object.assign({}, section);
      organizedSection.courses = [];

      if (!section.courses || !section.courses.length) {
        return;
      }

      for (var i = 0; i < section.courses.length; i++) {
        var course = Object.assign({}, section.courses[i]);

        // set the course type and verify existence
        course.type = course.article && 'article' || course.video && 'video' || course.file && 'file' || course.quiz && 'quiz' || course.assessment && 'assessment' || course.scorm && 'scorm';
        if (!course.type || !course[course.type] || !course[course.type]._id) {
          continue;
        }

        course.formattedDuration = '--';
        if (course[course.type].duration && typeof course[course.type].duration === 'number') {
          course.duration = course[course.type].duration;
          course.formattedDuration = self.formatDuration(course.duration);
          self.totalDuration += course.duration;
        }

        if (self.originalUserTrack && self.originalUserTrack.last_viewed && course[course.type]._id.toString() === self.originalUserTrack.last_viewed.toString() && !self.originalUserTrack.completed_date) {
          course.resume = true;
        }

        course.link = '/view/tracks/' + self.originalTrack._id + '/' + self.typesDirectory[course.type] + '/' + course[course.type]._id;
        self.contentDirectory[course[course.type]._id] = course[course.type];

        // set the course type and verify existence
        self.totalCourses++;
        organizedSection.courses.push(course);

        if (course.resume) {
          var resumeSection = organizedSection && organizedSection.position || 1;
          var coursePosition = course && course.position || 1;
          self.resumeLocation = [resumeSection - 1, coursePosition - 1];
        }
      }

      self.sortBy(organizedSection.courses, 'position');
      self.track.push(organizedSection);
    });

    this.totalDuration = Math.round(this.totalDuration / 3600) || 0;
    this.sortBy(this.track, 'position');
  };

  OrganizedTrack.prototype.setAvailability = function(uTrack) {
    if (!this.track || !this.track.length) {
      return;
    }

    var self = this;
    var completedItems = this.userCompleted(uTrack || this.originalUserTrack);
    this.completedCourses = 0;
    var previousComplete = false;
    var earliestNext = {
      section: 0,
      course: 0
    };
    var firstUnfinished = null;

    this.track.forEach(function(section, index) {
      if (!section.courses || !section.courses.length) {
        return;
      }
      for (var i = 0; i < section.courses.length; i++) {
        section.courses[i].completed = false;
        section.courses[i].available = false;
        if (completedItems[section.courses[i][section.courses[i].type]._id]) {
          section.courses[i].completed = true;
          section.courses[i].available = true;
          previousComplete = true;
          self.completedCourses++;
          continue;
        }

        if (!self.originalTrack.sequential) {
          section.courses[i].available = true;
          if (!earliestNext) {
            earliestNext = {
              section: index,
              course: i
            };
          }
          previousComplete = false;
          continue;
        }

        if (index === 0 && i === 0) {
          section.courses[i].available = true;
          previousComplete = false;
          firstUnfinished = true;
          continue;
        }

        if (previousComplete && !firstUnfinished) {
          previousComplete = false;
          section.courses[i].available = true;
          if (!earliestNext) {
            earliestNext = {
              section: index,
              course: i
            };
          }
          firstUnfinished = true;
          continue;
        }
        previousComplete = false;
      }
    });

    if (this.progressFunction) {
      this.progressFunction({
        percentComplete: Math.floor(this.completedCourses / this.totalCourses * 100),
        nextSectionIndex: earliestNext.section,
        nextCourseIndex: earliestNext.course
      });
    }

  };

  OrganizedTrack.prototype.setProgressFunction = function(fn) {
    this.progressFunction = fn;
  };

  OrganizedTrack.prototype.navigate = function(contentId) {
    for (var i = 0; i < this.track.length; i++) {
      var section = this.track[i];
      for (var j = 0; j < section.courses.length; j++) {
        var course = section.courses[j];
        if (!course.type || !course[course.type] || !course[course.type]._id) {
          continue;
        }
        if (course[course.type]._id.toString() !== contentId) {
          continue;
        }
        if (this.originalTrack.sequential && !this.originalTrack.resource && !course.available) {
          return {
            status: 'error',
            reason: 'All prior items must be completed before this item is available.'
          };
        }

        return {
          status: 'success',
          sectionIndex: i,
          courseIndex: j
        };
      }
    }

    return {
      status: 'error',
      reason: 'The requested item either does not exist or is currently unavailable.'
    };
  };

  OrganizedTrack.prototype.viewedCertificate = function() {
    var self = this;
    UserTracks.update({
      subresource: this.originalUserTrack._id,
      fields: 'track,user,completed_articles,completed_media,completed_quizzes,completed_assessments,completed_scorm,completed_date,last_viewed,viewed_certificate'
    }, {viewed_certificate: true}).$promise.then(function(data) {
      return;
    }).catch(function(error) {
      console.log('error: ', error)
    });
  };

  OrganizedTrack.prototype.checkTrackCompletion = function(utrack) {
    var self = this;
    var deferred = $q.defer();
    if (utrack.completed_date) {
      deferred.resolve({
        status: 'not modified',
        reason: 'user track already completed.'
      });
      return deferred.promise;
    }
    var completedItems = this.userCompleted(utrack);
    for (var i = 0; i < this.track.length; i++) {
      for (var j = 0; j < this.track[i].courses.length; j++) {
        var course = this.track[i].courses[j];
        var id = course && course.type && course[course.type]._id;
        if (!id) {
          deferred.reject({
            status: 'error',
            reason: 'could not determine _id of some content.'
          });
          return deferred.promise;
        }
        if (!completedItems[id]) {
          deferred.resolve({
            status: 'not modified',
            reason: 'not done.'
          });
          return deferred.promise;
        }
      }
    }

    var completeDate = {
      completed_date: new Date()
    };

    UserTracks.update({
      subresource: this.originalUserTrack._id,
      fields: 'track,user,completed_articles,completed_media,completed_quizzes,completed_assessments,completed_scorm,completed_date,last_viewed'
    }, completeDate).$promise.then(function(data) {
      self.originalUserTrack = data;
      deferred.resolve({
        status: 'track completed'
      });
    }).catch(function(error) {
      console.log('Error occured setting complete date in user track ', error);
      deferred.reject({
        status: 'error',
        reason: 'Could not update user track.'
      });
      if (error && error.message && error.stack) {
        var info = self.getErrorInfo();
        ErrorReporting.send({
          message: 'Error in userTrack completion request. User (' + info.user + ') in company (' + info.company + ') with track (' + info.track + ')',
          context: error
        });
      }
    });

    return deferred.promise;
  };

  OrganizedTrack.prototype.completeItem = function(course, attempt) {
    var self = this;
    var deferred = $q.defer();
    var content = course[course.type];
    if (!content || !content._id) {
      deferred.reject({status: 'error', reason: 'Content not provided at course type.'});
      return deferred.promise;
    }

    var type = course.type === 'video' || course.type === 'file' ? 'media' : course.type;
    var completedCheck = this.originalUserTrack['completed_' + this.typesDirectory[type]];
    if (completedCheck.length && completedCheck.indexOf(content._id.toString()) !== -1) {
      deferred.resolve({status: 'not modified', reason: 'Item is already completed.'});
      return deferred.promise;
    }
    // Update the user track to complete this item
    function completeRequest () {
      if (type !== 'assessment') {
        return UserTracks.complete({
          subresource: self.originalUserTrack._id,
          contentId: content._id,
          type: type,
          fields: 'track,user,completed_articles,completed_media,completed_quizzes,completed_assessments,completed_scorm,completed_date,last_viewed'
        }, null).$promise;
      }
      return self.getUserTrack();
    }

    completeRequest()
    .then(function(data) {
      data = data.length && data[0] || data;
      self.originalUserTrack = Object.assign(self.originalUserTrack, data);
      self.setAvailability(self.originalUserTrack);
      // Content complete call for event, workflow, and assignments
      Analyze.record(
        {resource: 'tracks'},
        {track: self.originalTrack._id, status: 'progress', percentage: Math.round(self.completedCourses / self.totalCourses * 100)}
      ).$promise.catch(function(error) {
        if (error && error.message && error.stack) {
          var info = self.getErrorInfo();
          ErrorReporting.send({
            message: 'Error in analyze track completion request. User (' + info.user + ') in company (' + info.company + ') with track (' + info.track + ')',
            context: error
          });
        }
      });
      self.checkTrackCompletion(self.originalUserTrack)
      .then(function(results) {
        deferred.resolve(results);
      }).catch(function(error) {
        // Reporting already handled
        deferred.reject(error);
      });
    }).catch(function(error) {
      if (error && error.message && error.stack) {
        var info = self.getErrorInfo();
        ErrorReporting.send({
          message: 'User (' + info.user + ') in company (' + info.company + ') was unable to complete course (' + (content && content._id || 'could not find') + ') in track (' + info.track + ')',
          context: error
        });
      }
    });
    return deferred.promise;
  };

  OrganizedTrack.prototype.createUserTrack = function(user) {
    var self = this;
    if (!user || !user._id || !this.originalTrack || !this.originalTrack._id) {
      var deferred = $q.defer();
      deferred.reject(null);
      return deferred.promise;
    }

    var uTrackData = {
      user: user._id,
      track: this.originalTrack._id,
      completed_media: [],
      completed_articles: [],
      completed_quizzes: [],
      completed_assessments: [],
      completed_scorm: []
    };

    return UserTracks.create(null, uTrackData).$promise.catch(function(error) {
      if (error && error.message && error.stack) {
        var info = self.getErrorInfo();
        ErrorReporting.send({
          message: 'Error in creating user track request. User (' + info.user + ') in company (' + info.company + ') with track (' + info.track + ')',
          context: {error: error, attemptedBody: uTrackData}
        });
      }
    });
  };

  // Begin organization after both requests are complete
  OrganizedTrack.prototype.initialize = function() {
    var self = this;
    return $q.all([this.getTrack(), this.getUserTrack()])
    .then(function(results) {
      self.originalTrack = results[0];
      self.originalUserTrack = {};
      if (results[1] && results[1].length) {
        self.originalUserTrack = results[1][0];
      }
      self.orderTrack();
      self.setAvailability();
    }).catch(function(error) {
      if (error && error.message && error.stack) {
        var info = self.getErrorInfo();
        ErrorReporting.send({
          message: 'We were unable to initialize Track (' + info.track + ') for User (' + info.user + ') in company (' + info.company + ')',
          context: error
        });
      }
    });
  };

  return {
    OrganizedTrack: OrganizedTrack
  };

}]);